import { Content } from "../../../general/modules/commons/content/content";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { Link } from "react-router-dom";
import tiresets from "../../../general/modules/commons/sidebarMenu/assets/tiresets.svg";
import request from "../../../general/modules/commons/sidebarMenu/assets/request.svg";
import planning from "../../../general/modules/commons/sidebarMenu/assets/planning.svg";
import slip from "../../../general/modules/commons/sidebarMenu/assets/slip.svg";

export const DashboardPage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();

  const title = t("Dashboard");

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
            <div>
              <LayoutHeaderTitle title={title} />
            </div>
            <div className="flex-grow-1 mx-md-3 my-2 my-md-0">
              <Breadcrumb>
                <BreadCrumbItem>{title}</BreadCrumbItem>
              </Breadcrumb>
            </div>
          </div>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <div className={"dashboard-buttons-wrapper"}>
            <div className={"mt-2 d-flex flex-wrap"}>
              <Link to={"/requests/create"}>
                <div className={"button-card button-card-green"}>
                  <span className="button-card-icon">
                    <img src={request} alt={"requests"} />
                  </span>
                  <h1>{t("Create request")}</h1>
                </div>
              </Link>

              <Link to="/tire-sets">
                <div className={"button-card button-card-blue"}>
                  <span className="button-card-icon">
                    <img src={tiresets} alt={"requests"} />
                  </span>
                  <h1>{t("Tireset overview")}</h1>
                </div>
              </Link>

              <Link to="/packing-slips">
                <div className={"button-card button-card-yellow"}>
                  <span className="button-card-icon">
                    <img src={slip} alt={"slip"} />
                  </span>
                  <h1>{t("Packing slips")}</h1>
                </div>
              </Link>

              <Link to="/requests">
                <div className={"button-card button-card-purple"}>
                  <span className="button-card-icon">
                    <img src={planning} alt={"requests"} />
                  </span>
                  <h1>{t("Open requests")}</h1>
                </div>
              </Link>
            </div>
          </div>
        </Content>
      </LayoutContent>
    </Layout>
  );
};
